(function() {
    'use strict';
    var isProductPage = window.location.pathname.indexOf('/products/') >= 0;

    // ===== 1. Image Zoom + Lightbox =====
    function setupImageZoom() {
        if (!isProductPage) return;
        var galleryImages = document.querySelectorAll('.product__media img, .product-gallery img, .product-single__media img, .slick-slide img');
        if (!galleryImages.length) return;

        // Create lightbox
        var lightbox = document.createElement('div');
        lightbox.id = 'xidu-lightbox';
        lightbox.innerHTML = '<div id="xidu-lightbox-close">✕</div><img src="" alt="Product image">';
        document.body.appendChild(lightbox);

        galleryImages.forEach(function(img) {
            if (img.closest('#xidu-lightbox')) return;
            var wrapper = img.parentElement;
            if (!wrapper.classList.contains('xidu-product-gallery')) {
                wrapper.classList.add('xidu-product-gallery');
                var hint = document.createElement('div');
                hint.className = 'xidu-zoom-hint';
                hint.textContent = 'Hover to zoom · Click to enlarge';
                wrapper.appendChild(hint);
            }

            // Click to open lightbox
            img.addEventListener('click', function(e) {
                if (e.target !== img) return;
                var fullSrc = img.src.replace('_300x300', '_1024x1024').replace('_600x600', '_1024x1024').replace('_400x', '_1024x');
                lightbox.querySelector('img').src = fullSrc;
                lightbox.classList.add('active');
            });
        });

        // Close lightbox
        lightbox.addEventListener('click', function() {
            lightbox.classList.remove('active');
        });
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') lightbox.classList.remove('active');
        });
    }

    // ===== 2. Related Products =====
    function setupRelatedProducts() {
        if (!isProductPage) return;
        if (document.querySelector('#xidu-related-products')) return;

        // Get current product handle from URL
        var match = window.location.pathname.match(/\/products\/(.+)/);
        if (!match) return;
        var currentHandle = match[1];

        // Fetch product recommendations from Shopify
        var productIdMeta = document.querySelector('meta[property="og:type"]');
        // Try Shopify Product Recommendations API
        var script = document.createElement('script');
        
        fetch('/recommendations/products.json?product_id=' + getProductId())
            .then(function(r) { return r.json(); })
            .then(function(data) {
                if (!data.products || data.products.length === 0) return;
                var products = data.products.slice(0, 4);
                renderRelatedProducts(products);
            })
            .catch(function() {
                // Fallback: fetch from collections
                fetch('/collections/all/products.json?limit=5')
                    .then(function(r) { return r.json(); })
                    .then(function(data) {
                        if (!data.products) return;
                        var products = data.products.filter(function(p) { return p.handle !== currentHandle; }).slice(0, 4);
                        renderRelatedProducts(products);
                    })
                    .catch(function() {});
            });

        function getProductId() {
            // Try to extract from page
            var form = document.querySelector('form[action*="/cart/add"]');
            if (form) {
                var idInput = form.querySelector('input[name="id"]');
                if (idInput) return idInput.value;
            }
            // Try meta
            var meta = document.querySelector('meta[name="product_id"]');
            if (meta) return meta.content;
            return '';
        }

        function renderRelatedProducts(products) {
            if (!products.length) return;
            var section = document.createElement('section');
            section.id = 'xidu-related-products';
            var cards = products.map(function(p) {
                var imgSrc = p.featured_image || '/assets/no-image.png';
                var price = p.price ? '$' + (p.price / 100).toFixed(2) : '';
                var compareAt = p.compare_at_price ? '<span style="text-decoration:line-through;color:#aaa;font-size:0.78rem;margin-right:4px;">$' + (p.compare_at_price / 100).toFixed(2) + '</span>' : '';
                return '<a href="/products/' + p.handle + '" class="xidu-related-card">' +
                    '<img src="' + imgSrc + '" alt="' + (p.title || '') + '" loading="lazy">' +
                    '<div class="xidu-related-info">' +
                    '<div class="xidu-related-title">' + (p.title || '') + '</div>' +
                    '<div class="xidu-related-price">' + compareAt + price + '</div>' +
                    '</div></a>';
            }).join('');
            section.innerHTML = '<h2>You May Also Like</h2><div class="xidu-related-grid">' + cards + '</div>';

            var mainContent = document.querySelector('#MainContent, main, .main-content');
            if (mainContent) {
                mainContent.appendChild(section);
            }
        }
    }

    // ===== 3. Product FAQ =====
    function setupFAQ() {
        if (!isProductPage) return;
        if (document.querySelector('#xidu-product-faq')) return;

        var faqs = [
            { q: 'Are the crystals real?', a: 'Yes, all our crystals are 100% natural and genuine. Each piece is carefully selected for quality and energy.' },
            { q: 'How do I care for my crystal bracelet?', a: 'Avoid contact with water, perfumes, and chemicals. Clean gently with a soft cloth. Store in a dry place away from direct sunlight.' },
            { q: 'What size should I choose?', a: 'Our bracelets are adjustable and fit wrist sizes from 16cm to 20cm. If you need a custom size, try our DIY Designer for a personalized fit.' },
            { q: 'How long does shipping take?', a: 'Orders are processed within 1-2 business days. Standard shipping takes 7-14 business days. Free shipping on orders over $30.' },
            { q: 'Can I return my purchase?', a: 'Yes, we offer a 30-day return policy for unused items in original packaging. Custom DIY pieces are final sale.' }
        ];

        var faqSection = document.createElement('section');
        faqSection.id = 'xidu-product-faq';
        var faqHTML = '<h2>Frequently Asked Questions</h2>';
        faqs.forEach(function(item) {
            faqHTML += '<div class="xidu-faq-item">' +
                '<div class="xidu-faq-question"><span>' + item.q + '</span><span class="xidu-faq-icon">+</span></div>' +
                '<div class="xidu-faq-answer"><p>' + item.a + '</p></div>' +
                '</div>';
        });
        faqSection.innerHTML = faqHTML;

        // Insert after related products or at end of main content
        var insertAfter = document.querySelector('#xidu-related-products') || document.querySelector('.product__info, .product-info, .product-single__info');
        if (insertAfter && insertAfter.parentNode) {
            insertAfter.parentNode.insertBefore(faqSection, insertAfter.nextSibling);
        } else {
            var main = document.querySelector('#MainContent, main');
            if (main) main.appendChild(faqSection);
        }

        // Accordion behavior
        faqSection.querySelectorAll('.xidu-faq-question').forEach(function(q) {
            q.addEventListener('click', function() {
                var item = q.parentElement;
                var isOpen = item.classList.contains('open');
                faqSection.querySelectorAll('.xidu-faq-item').forEach(function(i) { i.classList.remove('open'); });
                if (!isOpen) item.classList.add('open');
            });
        });
    }

    // ===== 4. Sticky Add-to-Cart Bar =====
    function setupStickyCart() {
        if (!isProductPage) return;
        if (document.querySelector('#xidu-sticky-cart')) return;

        var addToCartBtn = document.querySelector('.product-form__buttons button[type="submit"], .shopify-payment-button button, button[name="add"]');
        if (!addToCartBtn) return;

        var productTitle = document.querySelector('.product__title h1, .product-title, h1.product-title, .product-single__title');
        var productPrice = document.querySelector('.price__regular .price-item, .product-price, .price-item--regular, .money');
        var productImage = document.querySelector('.product__media img, .product-gallery img, .product-single__media img');

        var stickyBar = document.createElement('div');
        stickyBar.id = 'xidu-sticky-cart';
        stickyBar.innerHTML = '<div class="xidu-sticky-info">' +
            (productImage ? '<img src="' + (productImage.src || '').replace('_600x', '_100x') + '" alt="">' : '') +
            '<div><div class="xidu-sticky-title">' + (productTitle ? productTitle.textContent.trim() : '') + '</div>' +
            '<div class="xidu-sticky-price">' + (productPrice ? productPrice.textContent.trim() : '') + '</div></div>' +
            '</div>' +
            '<button class="xidu-sticky-btn">Add to Cart</button>';
        document.body.appendChild(stickyBar);

        var stickyBtn = stickyBar.querySelector('.xidu-sticky-btn');
        stickyBtn.addEventListener('click', function() {
            addToCartBtn.click();
            stickyBtn.textContent = 'Adding...';
            setTimeout(function() { stickyBtn.textContent = 'Add to Cart'; }, 2000);
        });

        // Show/hide based on scroll position
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    stickyBar.classList.remove('visible');
                } else {
                    stickyBar.classList.add('visible');
                }
            });
        }, { threshold: 0 });

        // Observe the add-to-cart button — show sticky bar when it's out of view
        observer.observe(addToCartBtn);
    }

    // ===== INIT =====
    function init() {
        setupImageZoom();
        setupRelatedProducts();
        setupFAQ();
        setupStickyCart();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();